import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home-wrapper" */ '../views/home/HomeWrapper.vue')
  },
  {
    path: '/home',
    name: 'home-redirect',
    redirect: '/'
  },
  {
    path: '/market',
    name: 'market',
    component: () => import('../views/market/Market.vue')
  },
  {
    path: '/trading',
    name: 'trading',
    component: () => import('../views/trading/Trading.vue')
  },
  {
    path: '/loan',
    name: 'loan',
    component: () => import('../views/loan/Loan.vue')
  },
  {
    path: '/nfts',
    name: 'nfts',
    component: () => import('../views/nfts/Nfts.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/profile/Profile.vue')
  },
  {
    path: '/cruuency',
    name: 'cruuency',
    component: () => import('../views/cruuency/Cruuency.vue')
  },
  {
    path: '/profile/balance',
    name: 'balance',
    component: () => import('../views/profile/balance/index.vue')
  },
  {
    path: '/profile/invite',
    name: 'invite',
    component: () => import('../views/profile/invite/index.vue')
  },
  {
    path: '/profile/notification',
    name: 'notification',
    component: () => import('../views/profile/notification/index.vue')
  },
  {
    path: '/profile/settings',
    name: 'settings',
    component: () => import('../views/profile/components/ProfileSettings.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/help/index.vue')
  },
  {
    path: '/help/faq',
    name: 'faq',
    component: () => import('../views/help/faq/index.vue')
  },
  {
    path: '/pass/register',
    name: 'register',
    component: () => import('../views/pass/register/index.vue')
  },
  {
    path: '/pass/login',
    name: 'login',
    component: () => import('../views/pass/login/index.vue')
  },
  {
    path: '/pass/reset',
    name: 'reset',
    component: () => import('../views/pass/reset/index.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail/index.vue')
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: () => import('../views/Introduction/index.vue')
  },
  {
    path: '/help/notice',
    name: 'notice',
    component: () => import('../views/help/notice/index.vue')
  },
  {
    path: '/ai',
    name: 'ai',
    component: () => import('../views/ai/Ai.vue')
  },
  {
    path: '/api/loginCallback/google',
    name: 'google',
    component: () => import('../views/api/loginCallback/google.vue')
  },
  {
    path: '/landing2',
    name: 'landing2',
    component: () => import(/* webpackChunkName: "landing2" */ '../views/landing/index2.vue')
  },
  // 兼容邀请链接 /register?agent=xxx 重定向到 /pass/register
  {
    path: '/register',
    redirect: to => {
      return { path: '/pass/register', query: to.query }
    }
  },
  // 重定向
  {
    path: '*',
    redirect: '/'
  }

]

// 防止连续点击多次路由报错（含导航守卫重定向）
const isRouterNavError = err =>
  err._isRouter || err.name === 'NavigationDuplicated' || err.name === 'NavigationRedirected'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (isRouterNavError(err)) return Promise.resolve(false)
    throw err
  })
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (isRouterNavError(err)) return Promise.resolve(false)
    throw err
  })
}

const router = new VueRouter({
  // mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 访客模式：未登录时根据 visitor_mode 设置决定是否跳转
const authWhiteList = ['/pass/login', '/pass/register', '/pass/reset', '/introduction', '/api/loginCallback/google', '/ai', '/landing2']
const needsAuthPaths = ['/trading', '/profile', '/loan']
router.beforeEach((to, from, next) => {
  const store = router.app && router.app.$store;
  if (!store) { next(); return; }

  const visitorMode = store.state.visitorMode;
  const isLogin = store.state.isLogin;
  const isWhite = authWhiteList.some(p => to.path.startsWith(p));

  if (!isLogin && !isWhite && visitorMode && visitorMode !== 'open') {
    const target = visitorMode === 'register' ? '/pass/register' : '/pass/login';
    next(target);
    return;
  }

  // open 模式下，需要登录的页面仍然跳转登录
  if (!isLogin && visitorMode === 'open' && needsAuthPaths.some(p => to.path.startsWith(p))) {
    next('/pass/login');
    return;
  }

  // 首页重定向：如果首页被隐藏，跳转到第一个可见菜单
  if (to.path === '/' || to.path === '/home') {
    const keys = store.state.visibleMenuKeys;
    if (Array.isArray(keys) && keys.length > 0 && !keys.includes('/')) {
      next(keys[0]);
      return;
    }
  }
  next();
})

// 监听路由变化
router.afterEach((to, from) => {
  window.scrollTo(0, 0)

  // 🚀 新增：页面切换时确保WebSocket连接正常
  const store = router.app.$store;
  if (store && store.state.isLogin) {
    // 检查WebSocket连接状态
    const ws = store.state.ws;
    if (!ws || ws.readyState !== WebSocket.OPEN) {
      // 延迟重连，避免频繁连接
      setTimeout(() => {
        store.dispatch("GET_WS_MARKET").then((res) => {
        }).catch((err) => {
          console.error('页面切换后WebSocket重连失败:', err);
        });
      }, 1000);
    }
  }
})

export default router
